import { BedDouble, Bath, Users, Maximize2, Waves, Moon } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const FACTS = [
  { icon: BedDouble, label: "Bedrooms", value: "5" },
  { icon: Bath, label: "Bathrooms", value: "3" },
  { icon: Users, label: "Sleeps", value: "10" },
  { icon: Maximize2, label: "Floor area", value: "250 m²" },
  { icon: Waves, label: "Pool", value: "8m + toddler" },
  { icon: Moon, label: "Min. stay", value: "5 nights" },
];

export const PropertyFacts = () => (
  <section className="container-editorial -mt-12 md:-mt-16 relative z-20">
    <Reveal>
      <div className="bg-[hsl(var(--card))] rounded-2xl border border-[hsl(var(--border))] shadow-[0_30px_80px_-40px_rgba(0,0,0,0.25)] p-6 md:p-8">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-6 md:gap-2">
          {FACTS.map((f, i) => (
            <div
              key={f.label}
              className={`flex items-center gap-4 md:justify-center ${
                i > 0 ? "md:border-l md:border-[hsl(var(--border))] md:pl-4" : ""
              }`}
            >
              <f.icon size={22} strokeWidth={1.1} className="text-[hsl(var(--sage-deep))]" />
              <div>
                <div className="tracking-eyebrow text-[9px] text-[hsl(var(--muted-foreground))] mb-0.5">
                  {f.label}
                </div>
                <div className="font-display text-lg leading-tight">{f.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Reveal>
  </section>
);
